import { render, staticRenderFns } from "./report-index.vue?vue&type=template&id=2148671c&"
import script from "./report-index.vue?vue&type=script&lang=js&"
export * from "./report-index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports